const AVATAR_COLORS = [
  "#1565c0", // blue 800
  "#ad1457", // pink 800
  "#00838f", // cyan 800
  "#2e7d32", // green 800
  "#ef6c00", // orange 800
  "#6a1b9a", // purple 800
  "#c62828", // red 800
  "#4527a0", // deep purple 800
] as const

function hashName(name: string): number {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return Math.abs(hash)
}

export function getAvatarColor(name: string): string {
  return AVATAR_COLORS[hashName(name) % AVATAR_COLORS.length]
}

export function getInitials(firstName?: string | null, lastName?: string | null): string {
  const f = firstName?.trim().charAt(0) ?? ""
  const l = lastName?.trim().charAt(0) ?? ""
  return (f + l).toUpperCase() || "?"
}
